


















import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
//import Util from "../../../lib/util";
import util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Common from "../../../store/entities/common";
@Component
export default class EditCompanyacNames extends AbpBase {
  common: Common = new Common();
  save() {
    (this.$refs.commonForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "common/editcompanyacname",
          data: this.common,
        });
        (this.$refs.commonForm as any).resetFields();
        //this.$emit("save-success");
        //this.$emit("input", false);
        var that = this;
        this.$Modal.success({
          title: "提醒",
          content: "系统名称修改成功，请重新登录！",
          closable: false,
          onOk() {
            that.$store.commit("app/logout", this);
            util.abp.auth.clearToken();
            location.reload();
          },
        });
      }
    });
  }
  getcompanyacname() {
      this.common.acName=this.$store.state.common.AppName;
  }
  created() {
    this.getcompanyacname();
  }
  commonRule = {
    acName: [
      {
        required: true,
        message: "请输入系统名称",
        trigger: "blur",
      },
    ],
  };
}
